import { ref } from 'vue'
import { CategoriesService } from '@/services/categories-service'
import { ROUTE_NAMES } from '@/router/router-names'

const isOfflineProduct =
	(import.meta.env.VITE_IS_OFFLINE_PRODUCT || '__IS_OFFLINE_PRODUCT__') ===
	'true'

export const ROUTE_DEFINITIONS = {
	PAGE_DASHBOARD: {
		path: ROUTE_NAMES.PAGE_DASHBOARD.path,
		name: ROUTE_NAMES.PAGE_DASHBOARD.routeName,
		component: ROUTE_NAMES.PAGE_DASHBOARD.component,
		meta: {
			role: ROUTE_NAMES.PAGE_DASHBOARD.role,
			iconName: ROUTE_NAMES.PAGE_DASHBOARD.iconName,
			title: ref(ROUTE_NAMES.PAGE_DASHBOARD.label),
			subMenu: false,
		},
	},
	PAGE_USERS: {
		path: ROUTE_NAMES.PAGE_USERS.path,
		name: ROUTE_NAMES.PAGE_USERS.routeName,
		redirect: { name: ROUTE_NAMES.LIST_PLAYERS.routeName },
		meta: {
			role: ROUTE_NAMES.PAGE_USERS.role,
			iconName: ROUTE_NAMES.PAGE_USERS.iconName,
			title: ref(ROUTE_NAMES.PAGE_USERS.label),
			subMenu: isOfflineProduct
				? [
						ROUTE_NAMES.LIST_PLAYERS,
						ROUTE_NAMES.LIST_STAFF,
						ROUTE_NAMES.LIST_HALLS,
				  ]
				: [ROUTE_NAMES.LIST_PLAYERS, ROUTE_NAMES.LIST_STAFF],
		},
		children: isOfflineProduct
			? [
					{
						path: ROUTE_NAMES.LIST_PLAYERS.path,
						name: ROUTE_NAMES.LIST_PLAYERS.routeName,
						query: ROUTE_NAMES.LIST_PLAYERS.query,
						component: ROUTE_NAMES.LIST_PLAYERS.component,
						meta: {
							role: ROUTE_NAMES.LIST_PLAYERS.role,
						},
					},
					{
						path: ROUTE_NAMES.LIST_LOGOUT_PLAYERS.path,
						name: ROUTE_NAMES.LIST_LOGOUT_PLAYERS.routeName,
						component: ROUTE_NAMES.LIST_LOGOUT_PLAYERS.component,
						meta: {
							role: ROUTE_NAMES.LIST_LOGOUT_PLAYERS.role,
							title: ref(ROUTE_NAMES.LIST_LOGOUT_PLAYERS.label),
							subMenu: false,
							btnBack: false,
						},
					},
					{
						path: ROUTE_NAMES.LIST_STAFF.path,
						name: ROUTE_NAMES.LIST_STAFF.routeName,
						query: ROUTE_NAMES.LIST_STAFF.query,
						component: ROUTE_NAMES.LIST_STAFF.component,
						meta: {
							role: ROUTE_NAMES.LIST_STAFF.role,
						},
					},
					{
						path: ROUTE_NAMES.LIST_HALLS.path,
						name: ROUTE_NAMES.LIST_HALLS.routeName,
						query: ROUTE_NAMES.LIST_HALLS.query,
						component: ROUTE_NAMES.LIST_HALLS.component,
						meta: {
							role: ROUTE_NAMES.LIST_HALLS.role,
						},
					},
					{
						path: ROUTE_NAMES.LIST_PROMO_CODES_FOR_HALLS.path,
						name: ROUTE_NAMES.LIST_PROMO_CODES_FOR_HALLS.routeName,
						component: ROUTE_NAMES.LIST_PROMO_CODES_FOR_HALLS.component,
						meta: {
							role: ROUTE_NAMES.LIST_PROMO_CODES_FOR_HALLS.role,
							btnBack: true,
							title: ref(ROUTE_NAMES.LIST_PROMO_CODES_FOR_HALLS.label),
						},
					},
					{
						path: ROUTE_NAMES.DETAIL_PLAYER.path,
						name: ROUTE_NAMES.DETAIL_PLAYER.routeName,
						component: ROUTE_NAMES.DETAIL_PLAYER.component,
						redirect: { name: ROUTE_NAMES.DETAIL_PLAYER_INFO.routeName },
						meta: {
							role: ROUTE_NAMES.DETAIL_PLAYER.role,
							iconName: ROUTE_NAMES.DETAIL_PLAYER.iconName,
							title: ref(ROUTE_NAMES.DETAIL_PLAYER.label),
							name: ref(''),
							subMenu: [
								ROUTE_NAMES.DETAIL_PLAYER_INFO,
								ROUTE_NAMES.DETAIL_PLAYER_WALLETS,
								ROUTE_NAMES.DETAIL_PLAYER_PAYMENTS,
								ROUTE_NAMES.DETAIL_PLAYER_TRANSACTIONS,
								ROUTE_NAMES.DETAIL_PLAYER_DEPOSIT_REQUESTS,
								ROUTE_NAMES.DETAIL_PLAYER_DEPOSITS,
								ROUTE_NAMES.DETAIL_PLAYER_WITHDRAWALS_REQUESTS,
								ROUTE_NAMES.DETAIL_PLAYER_WITHDRAWALS,
								ROUTE_NAMES.DETAIL_PLAYER_GAMING_SESSIONS,
								ROUTE_NAMES.DETAIL_PLAYER_BONUSES,
								ROUTE_NAMES.DETAIL_PLAYER_FILES,
								ROUTE_NAMES.DETAIL_PLAYER_REQUISITES,
								ROUTE_NAMES.DETAIL_PLAYER_ACCOUNT,
							],
							btnBack: true,
						},
						children: [
							{
								path: ROUTE_NAMES.DETAIL_PLAYER_INFO.path,
								name: ROUTE_NAMES.DETAIL_PLAYER_INFO.routeName,
								component: ROUTE_NAMES.DETAIL_PLAYER_INFO.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_PLAYER_INFO.role,
								},
							},
							{
								path: ROUTE_NAMES.DETAIL_PLAYER_WALLETS.path,
								name: ROUTE_NAMES.DETAIL_PLAYER_WALLETS.routeName,
								component: ROUTE_NAMES.DETAIL_PLAYER_WALLETS.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_PLAYER_WALLETS.role,
								},
							},
							{
								path: ROUTE_NAMES.DETAIL_PLAYER_PAYMENTS.path,
								name: ROUTE_NAMES.DETAIL_PLAYER_PAYMENTS.routeName,
								component: ROUTE_NAMES.DETAIL_PLAYER_PAYMENTS.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_PLAYER_PAYMENTS.role,
								},
							},
							{
								path: ROUTE_NAMES.DETAIL_PLAYER_TRANSACTIONS.path,
								name: ROUTE_NAMES.DETAIL_PLAYER_TRANSACTIONS.routeName,
								component: ROUTE_NAMES.DETAIL_PLAYER_TRANSACTIONS.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_PLAYER_TRANSACTIONS.role,
								},
							},
							{
								path: ROUTE_NAMES.DETAIL_PLAYER_DEPOSIT_REQUESTS.path,
								name: ROUTE_NAMES.DETAIL_PLAYER_DEPOSIT_REQUESTS.routeName,
								component: ROUTE_NAMES.DETAIL_PLAYER_DEPOSIT_REQUESTS.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_PLAYER_DEPOSIT_REQUESTS.role,
								},
							},
							{
								path: ROUTE_NAMES.DETAIL_PLAYER_DEPOSITS.path,
								name: ROUTE_NAMES.DETAIL_PLAYER_DEPOSITS.routeName,
								component: ROUTE_NAMES.DETAIL_PLAYER_DEPOSITS.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_PLAYER_DEPOSITS.role,
								},
							},
							{
								path: ROUTE_NAMES.DETAIL_PLAYER_WITHDRAWALS_REQUESTS.path,
								name: ROUTE_NAMES.DETAIL_PLAYER_WITHDRAWALS_REQUESTS.routeName,
								component:
									ROUTE_NAMES.DETAIL_PLAYER_WITHDRAWALS_REQUESTS.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_PLAYER_WITHDRAWALS_REQUESTS.role,
								},
							},
							{
								path: ROUTE_NAMES.DETAIL_PLAYER_WITHDRAWALS.path,
								name: ROUTE_NAMES.DETAIL_PLAYER_WITHDRAWALS.routeName,
								component: ROUTE_NAMES.DETAIL_PLAYER_WITHDRAWALS.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_PLAYER_WITHDRAWALS.role,
								},
							},
							{
								path: ROUTE_NAMES.DETAIL_PLAYER_GAMING_SESSIONS.path,
								name: ROUTE_NAMES.DETAIL_PLAYER_GAMING_SESSIONS.routeName,
								component: ROUTE_NAMES.DETAIL_PLAYER_GAMING_SESSIONS.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_PLAYER_GAMING_SESSIONS.role,
								},
							},
							{
								path: ROUTE_NAMES.DETAIL_PLAYER_TRANSACTIONS_BY_SESSIONS.path,
								name: ROUTE_NAMES.DETAIL_PLAYER_TRANSACTIONS_BY_SESSIONS
									.routeName,
								component:
									ROUTE_NAMES.DETAIL_PLAYER_TRANSACTIONS_BY_SESSIONS.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_PLAYER_TRANSACTIONS_BY_SESSIONS.role,
								},
							},
							{
								path: ROUTE_NAMES.DETAIL_PLAYER_BONUSES.path,
								name: ROUTE_NAMES.DETAIL_PLAYER_BONUSES.routeName,
								component: ROUTE_NAMES.DETAIL_PLAYER_BONUSES.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_PLAYER_BONUSES.role,
								},
							},
							{
								path: ROUTE_NAMES.DETAIL_PLAYER_FILES.path,
								name: ROUTE_NAMES.DETAIL_PLAYER_FILES.routeName,
								component: ROUTE_NAMES.DETAIL_PLAYER_FILES.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_PLAYER_FILES.role,
								},
							},
							{
								path: ROUTE_NAMES.CREATE_PLAYER_BONUS.path,
								name: ROUTE_NAMES.CREATE_PLAYER_BONUS.routeName,
								component: ROUTE_NAMES.CREATE_PLAYER_BONUS.component,
								meta: {
									role: ROUTE_NAMES.CREATE_PLAYER_BONUS.role,
									title: ref(ROUTE_NAMES.CREATE_PLAYER_BONUS.label),
									subMenu: false,
								},
							},
							{
								path: ROUTE_NAMES.DETAIL_PLAYER_REQUISITES.path,
								name: ROUTE_NAMES.DETAIL_PLAYER_REQUISITES.routeName,
								component: ROUTE_NAMES.DETAIL_PLAYER_REQUISITES.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_PLAYER_REQUISITES.role,
								},
							},
							{
								path: ROUTE_NAMES.DETAIL_PLAYER_ACCOUNT.path,
								name: ROUTE_NAMES.DETAIL_PLAYER_ACCOUNT.routeName,
								component: ROUTE_NAMES.DETAIL_PLAYER_ACCOUNT.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_PLAYER_ACCOUNT.role,
								},
							},
						],
					},
					{
						path: ROUTE_NAMES.DETAIL_STAFF.path,
						name: ROUTE_NAMES.DETAIL_STAFF.routeName,
						component: ROUTE_NAMES.DETAIL_STAFF.component,
						meta: {
							role: ROUTE_NAMES.DETAIL_STAFF.role,
							title: ref(ROUTE_NAMES.DETAIL_STAFF.label),
							iconName: ROUTE_NAMES.DETAIL_STAFF.iconName,
							name: ref(''),
							btnBack: true,
							subMenu: false,
						},
					},
					{
						path: ROUTE_NAMES.DETAIL_HALL.path,
						name: ROUTE_NAMES.DETAIL_HALL.routeName,
						component: ROUTE_NAMES.DETAIL_HALL.component,
						redirect: { name: ROUTE_NAMES.DETAIL_HALL_INFO.routeName },
						meta: {
							role: ROUTE_NAMES.DETAIL_HALL.role,
							title: ref(ROUTE_NAMES.DETAIL_HALL.label),
							iconName: ROUTE_NAMES.DETAIL_HALL.iconName,
							name: ref(''),
							btnBack: true,
							subMenu: [
								ROUTE_NAMES.DETAIL_HALL_INFO,
								ROUTE_NAMES.DETAIL_HALL_GROUP_PLAYERS,
								ROUTE_NAMES.DETAIL_HALL_PLAYERS,
								ROUTE_NAMES.DETAIL_HALL_GROUP_SHIFTS,
								ROUTE_NAMES.DETAIL_HALL_REPORTS,
							],
						},
						children: [
							{
								path: ROUTE_NAMES.DETAIL_HALL_INFO.path,
								name: ROUTE_NAMES.DETAIL_HALL_INFO.routeName,
								component: ROUTE_NAMES.DETAIL_HALL_INFO.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_HALL_INFO.role,
								},
							},
							{
								path: ROUTE_NAMES.DETAIL_HALL_PLAYERS.path,
								name: ROUTE_NAMES.DETAIL_HALL_PLAYERS.routeName,
								component: ROUTE_NAMES.DETAIL_HALL_PLAYERS.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_HALL_PLAYERS.role,
								},
							},
							{
								path: ROUTE_NAMES.DETAIL_HALL_GROUP_PLAYERS.path,
								name: ROUTE_NAMES.DETAIL_HALL_GROUP_PLAYERS.routeName,
								component: ROUTE_NAMES.DETAIL_HALL_GROUP_PLAYERS.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_HALL_GROUP_PLAYERS.role,
								},
							},
							{
								path: ROUTE_NAMES.DETAIL_HALL_GROUP_SHIFTS.path,
								name: ROUTE_NAMES.DETAIL_HALL_GROUP_SHIFTS.routeName,
								component: ROUTE_NAMES.DETAIL_HALL_GROUP_SHIFTS.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_HALL_GROUP_SHIFTS.role,
								},
							},
							{
								path: ROUTE_NAMES.DETAIL_HALL_REPORTS.path,
								name: ROUTE_NAMES.DETAIL_HALL_REPORTS.routeName,
								component: ROUTE_NAMES.DETAIL_HALL_REPORTS.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_HALL_REPORTS.role,
								},
							},
						],
					},
					{
						path: ROUTE_NAMES.DETAIL_SHIFT.path,
						name: ROUTE_NAMES.DETAIL_SHIFT.routeName,
						component: ROUTE_NAMES.DETAIL_SHIFT.component,
						redirect: { name: ROUTE_NAMES.DETAIL_SHIFT_INFO.routeName },
						meta: {
							role: ROUTE_NAMES.DETAIL_SHIFT.role,
							title: ref(ROUTE_NAMES.DETAIL_SHIFT.label),
							iconName: ROUTE_NAMES.DETAIL_SHIFT.iconName,
							name: ref(''),
							btnBack: true,
							subMenu: [
								ROUTE_NAMES.DETAIL_SHIFT_INFO,
								ROUTE_NAMES.DETAIL_SHIFT_ACCOUNTS,
								ROUTE_NAMES.DETAIL_SHIFT_OPERATIONS,
							],
						},
						children: [
							{
								path: ROUTE_NAMES.DETAIL_SHIFT_INFO.path,
								name: ROUTE_NAMES.DETAIL_SHIFT_INFO.routeName,
								component: ROUTE_NAMES.DETAIL_SHIFT_INFO.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_SHIFT_INFO.role,
								},
							},
							{
								path: ROUTE_NAMES.DETAIL_SHIFT_ACCOUNTS.path,
								name: ROUTE_NAMES.DETAIL_SHIFT_ACCOUNTS.routeName,
								component: ROUTE_NAMES.DETAIL_SHIFT_ACCOUNTS.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_SHIFT_ACCOUNTS.role,
								},
							},
							{
								path: ROUTE_NAMES.DETAIL_SHIFT_OPERATIONS.path,
								name: ROUTE_NAMES.DETAIL_SHIFT_OPERATIONS.routeName,
								component: ROUTE_NAMES.DETAIL_SHIFT_OPERATIONS.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_SHIFT_OPERATIONS.role,
								},
							},
						],
					},
					{
						path: ROUTE_NAMES.DETAIL_REPORT.path,
						name: ROUTE_NAMES.DETAIL_REPORT.routeName,
						component: ROUTE_NAMES.DETAIL_REPORT.component,
						redirect: { name: ROUTE_NAMES.DETAIL_REPORT_INFO.routeName },
						meta: {
							role: ROUTE_NAMES.DETAIL_REPORT.role,
							title: ref(ROUTE_NAMES.DETAIL_REPORT.label),
							iconName: ROUTE_NAMES.DETAIL_REPORT.iconName,
							name: ref(''),
							btnBack: true,
							subMenu: [
								ROUTE_NAMES.DETAIL_REPORT_INFO,
								ROUTE_NAMES.DETAIL_REPORT_PLAYERS,
								ROUTE_NAMES.DETAIL_REPORT_TOTALS,
							],
						},
						children: [
							{
								path: ROUTE_NAMES.DETAIL_REPORT_INFO.path,
								name: ROUTE_NAMES.DETAIL_REPORT_INFO.routeName,
								component: ROUTE_NAMES.DETAIL_REPORT_INFO.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_REPORT_INFO.role,
								},
							},
							{
								path: ROUTE_NAMES.DETAIL_REPORT_PLAYERS.path,
								name: ROUTE_NAMES.DETAIL_REPORT_PLAYERS.routeName,
								component: ROUTE_NAMES.DETAIL_REPORT_PLAYERS.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_REPORT_PLAYERS.role,
								},
							},
							{
								path: ROUTE_NAMES.DETAIL_REPORT_TOTALS.path,
								name: ROUTE_NAMES.DETAIL_REPORT_TOTALS.routeName,
								component: ROUTE_NAMES.DETAIL_REPORT_TOTALS.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_REPORT_TOTALS.role,
								},
							},
						],
					},
			  ]
			: [
					{
						path: ROUTE_NAMES.LIST_PLAYERS.path,
						name: ROUTE_NAMES.LIST_PLAYERS.routeName,
						query: ROUTE_NAMES.LIST_PLAYERS.query,
						component: ROUTE_NAMES.LIST_PLAYERS.component,
						meta: {
							role: ROUTE_NAMES.LIST_PLAYERS.role,
						},
					},
					{
						path: ROUTE_NAMES.LIST_LOGOUT_PLAYERS.path,
						name: ROUTE_NAMES.LIST_LOGOUT_PLAYERS.routeName,
						component: ROUTE_NAMES.LIST_LOGOUT_PLAYERS.component,
						meta: {
							role: ROUTE_NAMES.LIST_LOGOUT_PLAYERS.role,
							title: ref(ROUTE_NAMES.LIST_LOGOUT_PLAYERS.label),
							subMenu: false,
							btnBack: false,
						},
					},
					{
						path: ROUTE_NAMES.LIST_STAFF.path,
						name: ROUTE_NAMES.LIST_STAFF.routeName,
						query: ROUTE_NAMES.LIST_STAFF.query,
						component: ROUTE_NAMES.LIST_STAFF.component,
						meta: {
							role: ROUTE_NAMES.LIST_STAFF.role,
						},
					},
					{
						path: ROUTE_NAMES.DETAIL_PLAYER.path,
						name: ROUTE_NAMES.DETAIL_PLAYER.routeName,
						component: ROUTE_NAMES.DETAIL_PLAYER.component,
						redirect: { name: ROUTE_NAMES.DETAIL_PLAYER_INFO.routeName },
						meta: {
							role: ROUTE_NAMES.DETAIL_PLAYER.role,
							iconName: ROUTE_NAMES.DETAIL_PLAYER.iconName,
							title: ref(ROUTE_NAMES.DETAIL_PLAYER.label),
							name: ref(''),
							subMenu: [
								ROUTE_NAMES.DETAIL_PLAYER_INFO,
								ROUTE_NAMES.DETAIL_PLAYER_WALLETS,
								ROUTE_NAMES.DETAIL_PLAYER_PAYMENTS,
								ROUTE_NAMES.DETAIL_PLAYER_TRANSACTIONS,
								ROUTE_NAMES.DETAIL_PLAYER_DEPOSIT_REQUESTS,
								ROUTE_NAMES.DETAIL_PLAYER_DEPOSITS,
								ROUTE_NAMES.DETAIL_PLAYER_WITHDRAWALS_REQUESTS,
								ROUTE_NAMES.DETAIL_PLAYER_WITHDRAWALS,
								ROUTE_NAMES.DETAIL_PLAYER_GAMING_SESSIONS,
								ROUTE_NAMES.DETAIL_PLAYER_BONUSES,
								ROUTE_NAMES.DETAIL_PLAYER_FILES,
								ROUTE_NAMES.DETAIL_PLAYER_REQUISITES,
								ROUTE_NAMES.DETAIL_PLAYER_ACCOUNT,
							],
							btnBack: true,
						},
						children: [
							{
								path: ROUTE_NAMES.DETAIL_PLAYER_INFO.path,
								name: ROUTE_NAMES.DETAIL_PLAYER_INFO.routeName,
								component: ROUTE_NAMES.DETAIL_PLAYER_INFO.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_PLAYER_INFO.role,
								},
							},
							{
								path: ROUTE_NAMES.DETAIL_PLAYER_WALLETS.path,
								name: ROUTE_NAMES.DETAIL_PLAYER_WALLETS.routeName,
								component: ROUTE_NAMES.DETAIL_PLAYER_WALLETS.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_PLAYER_WALLETS.role,
								},
							},
							{
								path: ROUTE_NAMES.DETAIL_PLAYER_PAYMENTS.path,
								name: ROUTE_NAMES.DETAIL_PLAYER_PAYMENTS.routeName,
								component: ROUTE_NAMES.DETAIL_PLAYER_PAYMENTS.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_PLAYER_PAYMENTS.role,
								},
							},
							{
								path: ROUTE_NAMES.DETAIL_PLAYER_TRANSACTIONS.path,
								name: ROUTE_NAMES.DETAIL_PLAYER_TRANSACTIONS.routeName,
								component: ROUTE_NAMES.DETAIL_PLAYER_TRANSACTIONS.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_PLAYER_TRANSACTIONS.role,
								},
							},
							{
								path: ROUTE_NAMES.DETAIL_PLAYER_DEPOSIT_REQUESTS.path,
								name: ROUTE_NAMES.DETAIL_PLAYER_DEPOSIT_REQUESTS.routeName,
								component: ROUTE_NAMES.DETAIL_PLAYER_DEPOSIT_REQUESTS.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_PLAYER_DEPOSIT_REQUESTS.role,
								},
							},
							{
								path: ROUTE_NAMES.DETAIL_PLAYER_DEPOSITS.path,
								name: ROUTE_NAMES.DETAIL_PLAYER_DEPOSITS.routeName,
								component: ROUTE_NAMES.DETAIL_PLAYER_DEPOSITS.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_PLAYER_DEPOSITS.role,
								},
							},
							{
								path: ROUTE_NAMES.DETAIL_PLAYER_WITHDRAWALS_REQUESTS.path,
								name: ROUTE_NAMES.DETAIL_PLAYER_WITHDRAWALS_REQUESTS.routeName,
								component:
									ROUTE_NAMES.DETAIL_PLAYER_WITHDRAWALS_REQUESTS.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_PLAYER_WITHDRAWALS_REQUESTS.role,
								},
							},
							{
								path: ROUTE_NAMES.DETAIL_PLAYER_WITHDRAWALS.path,
								name: ROUTE_NAMES.DETAIL_PLAYER_WITHDRAWALS.routeName,
								component: ROUTE_NAMES.DETAIL_PLAYER_WITHDRAWALS.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_PLAYER_WITHDRAWALS.role,
								},
							},
							{
								path: ROUTE_NAMES.DETAIL_PLAYER_GAMING_SESSIONS.path,
								name: ROUTE_NAMES.DETAIL_PLAYER_GAMING_SESSIONS.routeName,
								component: ROUTE_NAMES.DETAIL_PLAYER_GAMING_SESSIONS.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_PLAYER_GAMING_SESSIONS.role,
								},
							},
							{
								path: ROUTE_NAMES.DETAIL_PLAYER_TRANSACTIONS_BY_SESSIONS.path,
								name: ROUTE_NAMES.DETAIL_PLAYER_TRANSACTIONS_BY_SESSIONS
									.routeName,
								component:
									ROUTE_NAMES.DETAIL_PLAYER_TRANSACTIONS_BY_SESSIONS.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_PLAYER_TRANSACTIONS_BY_SESSIONS.role,
								},
							},
							{
								path: ROUTE_NAMES.DETAIL_PLAYER_BONUSES.path,
								name: ROUTE_NAMES.DETAIL_PLAYER_BONUSES.routeName,
								component: ROUTE_NAMES.DETAIL_PLAYER_BONUSES.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_PLAYER_BONUSES.role,
								},
							},
							{
								path: ROUTE_NAMES.CREATE_PLAYER_BONUS.path,
								name: ROUTE_NAMES.CREATE_PLAYER_BONUS.routeName,
								component: ROUTE_NAMES.CREATE_PLAYER_BONUS.component,
								meta: {
									role: ROUTE_NAMES.CREATE_PLAYER_BONUS.role,
									title: ref(ROUTE_NAMES.CREATE_PLAYER_BONUS.label),
									subMenu: false,
								},
							},
							{
								path: ROUTE_NAMES.DETAIL_PLAYER_REQUISITES.path,
								name: ROUTE_NAMES.DETAIL_PLAYER_REQUISITES.routeName,
								component: ROUTE_NAMES.DETAIL_PLAYER_REQUISITES.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_PLAYER_REQUISITES.role,
								},
							},
							{
								path: ROUTE_NAMES.DETAIL_PLAYER_ACCOUNT.path,
								name: ROUTE_NAMES.DETAIL_PLAYER_ACCOUNT.routeName,
								component: ROUTE_NAMES.DETAIL_PLAYER_ACCOUNT.component,
								meta: {
									role: ROUTE_NAMES.DETAIL_PLAYER_ACCOUNT.role,
								},
							},
						],
					},
					{
						path: ROUTE_NAMES.DETAIL_STAFF.path,
						name: ROUTE_NAMES.DETAIL_STAFF.routeName,
						component: ROUTE_NAMES.DETAIL_STAFF.component,
						meta: {
							role: ROUTE_NAMES.DETAIL_STAFF.role,
							title: ref(ROUTE_NAMES.DETAIL_STAFF.label),
							iconName: ROUTE_NAMES.DETAIL_STAFF.iconName,
							name: ref(''),
							btnBack: true,
							subMenu: false,
						},
					},
			  ],
	},
	GAMES_PAGE: {
		path: ROUTE_NAMES.PAGE_GAMES.path,
		name: ROUTE_NAMES.PAGE_GAMES.routeName,
		redirect: { name: ROUTE_NAMES.LIST_GAMES.routeName },
		meta: {
			role: ROUTE_NAMES.PAGE_GAMES.role,
			title: ref(ROUTE_NAMES.PAGE_GAMES.label),
			iconName: ROUTE_NAMES.PAGE_GAMES.iconName,
			subMenu: [
				ROUTE_NAMES.LIST_GAMES,
				ROUTE_NAMES.LIST_CATEGORIES,
				ROUTE_NAMES.LIST_TAGS,
				ROUTE_NAMES.LIST_MAINTENANCES,
				ROUTE_NAMES.LIST_PROVIDERS_INTEGRATIONS,
				ROUTE_NAMES.LIST_TRANSACTIONS_BY_INTEGRATIONS,
			],
		},
		children: [
			{
				path: ROUTE_NAMES.LIST_GAMES.path,
				name: ROUTE_NAMES.LIST_GAMES.routeName,
				query: ROUTE_NAMES.LIST_GAMES.query,
				component: ROUTE_NAMES.LIST_GAMES.component,
				meta: {
					role: ROUTE_NAMES.LIST_GAMES.role,
				},
			},
			{
				path: ROUTE_NAMES.DETAIL_GAME.path,
				name: ROUTE_NAMES.DETAIL_GAME.routeName,
				component: ROUTE_NAMES.DETAIL_GAME.component,
				redirect: { name: ROUTE_NAMES.DETAIL_GAME.routeName },
				meta: {
					role: ROUTE_NAMES.DETAIL_GAME.role,
					title: ref(ROUTE_NAMES.DETAIL_GAME.label),
					name: ref(),
					subMenu: [
						ROUTE_NAMES.DETAIL_GAME_INFO,
						ROUTE_NAMES.DETAIL_GAME_METRIC,
					],
					btnBack: true,
				},
				children: [
					{
						path: ROUTE_NAMES.DETAIL_GAME_INFO.path,
						name: ROUTE_NAMES.DETAIL_GAME_INFO.routeName,
						component: ROUTE_NAMES.DETAIL_GAME_INFO.component,
						meta: {
							role: ROUTE_NAMES.DETAIL_GAME_INFO.role,
						},
					},
					{
						path: ROUTE_NAMES.DETAIL_GAME_METRIC.path,
						name: ROUTE_NAMES.DETAIL_GAME_METRIC.routeName,
						component: ROUTE_NAMES.DETAIL_GAME_METRIC.component,
						meta: {
							role: ROUTE_NAMES.DETAIL_GAME_METRIC.role,
						},
					},
				],
			},
			{
				path: ROUTE_NAMES.CREATE_GAMES.path,
				name: ROUTE_NAMES.CREATE_GAMES.routeName,
				component: ROUTE_NAMES.CREATE_GAMES.component,
				meta: {
					role: ROUTE_NAMES.CREATE_GAMES.role,
					title: ref(ROUTE_NAMES.CREATE_GAMES.label),
					subMenu: false,
					btnBack: true,
				},
			},

			{
				path: ROUTE_NAMES.LIST_CATEGORIES.path,
				name: ROUTE_NAMES.LIST_CATEGORIES.routeName,
				component: ROUTE_NAMES.LIST_CATEGORIES.component,
				query: ROUTE_NAMES.LIST_CATEGORIES.query,
				meta: {
					role: ROUTE_NAMES.LIST_CATEGORIES.role,
				},
			},
			{
				path: ROUTE_NAMES.DETAIL_CATEGORY.path,
				name: ROUTE_NAMES.DETAIL_CATEGORY.routeName,
				component: ROUTE_NAMES.DETAIL_CATEGORY.component,
				redirect: { name: ROUTE_NAMES.DETAIL_CATEGORY_INFO.routeName },
				meta: {
					role: ROUTE_NAMES.DETAIL_CATEGORY.role,
					title: ref(ROUTE_NAMES.DETAIL_CATEGORY.label),
					name: ref(),
					subMenu: [
						ROUTE_NAMES.DETAIL_CATEGORY_INFO,
						ROUTE_NAMES.DETAIL_CATEGORY_GAMES_LIST,
					],
					btnBack: true,
				},
				beforeEnter: async (to, from, next) => {
					to.meta.name.value = ''
					const resp = await CategoriesService.getCategoryById(to.params.id)
					to.meta.name.value = resp.name || resp.id
					next()
				},
				children: [
					{
						path: ROUTE_NAMES.DETAIL_CATEGORY_INFO.path,
						name: ROUTE_NAMES.DETAIL_CATEGORY_INFO.routeName,
						component: ROUTE_NAMES.DETAIL_CATEGORY_INFO.component,
						meta: {
							role: ROUTE_NAMES.DETAIL_CATEGORY_INFO.role,
						},
					},
					{
						path: ROUTE_NAMES.DETAIL_CATEGORY_GAMES_LIST.path,
						name: ROUTE_NAMES.DETAIL_CATEGORY_GAMES_LIST.routeName,
						component: ROUTE_NAMES.DETAIL_CATEGORY_GAMES_LIST.component,
						meta: {
							role: ROUTE_NAMES.DETAIL_CATEGORY_GAMES_LIST.role,
						},
					},
					{
						path: ROUTE_NAMES.DETAIL_CATEGORY_EDIT_GAMES_LIST.path,
						name: ROUTE_NAMES.DETAIL_CATEGORY_EDIT_GAMES_LIST.routeName,
						component: ROUTE_NAMES.DETAIL_CATEGORY_EDIT_GAMES_LIST.component,
						meta: {
							role: ROUTE_NAMES.DETAIL_CATEGORY_EDIT_GAMES_LIST.role,
							title: ref(ROUTE_NAMES.DETAIL_CATEGORY_EDIT_GAMES_LIST.label),
							subMenu: false,
						},
						beforeEnter: async (to, from, next) => {
							const categoryDetailPage = to.matched.find(
								el => el.name === ROUTE_NAMES.DETAIL_CATEGORY.routeName
							)
							categoryDetailPage.meta.name.value = ''
							const resp = await CategoriesService.getCategoryById(to.params.id)
							categoryDetailPage.meta.name.value = resp.name || resp.id
							next()
						},
					},
				],
			},
			{
				path: ROUTE_NAMES.CREATE_CATEGORY.path,
				name: ROUTE_NAMES.CREATE_CATEGORY.routeName,
				component: ROUTE_NAMES.CREATE_CATEGORY.component,
				query: ROUTE_NAMES.CREATE_CATEGORY.query,
				meta: {
					role: ROUTE_NAMES.CREATE_CATEGORY.role,
					title: ref(ROUTE_NAMES.CREATE_CATEGORY.label),
					subMenu: false,
					btnBack: true,
				},
			},

			{
				path: ROUTE_NAMES.LIST_TAGS.path,
				name: ROUTE_NAMES.LIST_TAGS.routeName,
				component: ROUTE_NAMES.LIST_TAGS.component,
				query: ROUTE_NAMES.LIST_TAGS.query,
				meta: {
					role: ROUTE_NAMES.LIST_TAGS.role,
				},
			},
			{
				path: ROUTE_NAMES.DETAIL_TAG.path,
				name: ROUTE_NAMES.DETAIL_TAG.routeName,
				component: ROUTE_NAMES.DETAIL_TAG.component,
				redirect: { name: ROUTE_NAMES.DETAIL_TAG_INFO.routeName },
				meta: {
					role: ROUTE_NAMES.DETAIL_TAG.role,
					title: ref(ROUTE_NAMES.DETAIL_TAG.label),
					name: ref(),
					subMenu: [
						ROUTE_NAMES.DETAIL_TAG_INFO,
						ROUTE_NAMES.DETAIL_TAG_EDIT_GAMES_LIST,
					],
					btnBack: true,
				},
				children: [
					{
						path: ROUTE_NAMES.DETAIL_TAG_INFO.path,
						name: ROUTE_NAMES.DETAIL_TAG_INFO.routeName,
						component: ROUTE_NAMES.DETAIL_TAG_INFO.component,
						meta: {
							role: ROUTE_NAMES.DETAIL_TAG_INFO.role,
						},
					},
					{
						path: ROUTE_NAMES.DETAIL_TAG_EDIT_GAMES_LIST.path,
						name: ROUTE_NAMES.DETAIL_TAG_EDIT_GAMES_LIST.routeName,
						component: ROUTE_NAMES.DETAIL_TAG_EDIT_GAMES_LIST.component,
						meta: {
							role: ROUTE_NAMES.DETAIL_TAG_EDIT_GAMES_LIST.role,
						},
					},
				],
			},
			{
				path: ROUTE_NAMES.CREATE_TAG.path,
				name: ROUTE_NAMES.CREATE_TAG.routeName,
				component: ROUTE_NAMES.CREATE_TAG.component,
				query: ROUTE_NAMES.CREATE_TAG.query,
				meta: {
					role: ROUTE_NAMES.CREATE_TAG.role,
					title: ref(ROUTE_NAMES.CREATE_TAG.label),
					subMenu: false,
					btnBack: true,
				},
			},

			{
				path: ROUTE_NAMES.LIST_MAINTENANCES.path,
				name: ROUTE_NAMES.LIST_MAINTENANCES.routeName,
				component: ROUTE_NAMES.LIST_MAINTENANCES.component,
				query: ROUTE_NAMES.LIST_MAINTENANCES.query,
				meta: {
					role: ROUTE_NAMES.LIST_MAINTENANCES.role,
				},
			},
			{
				path: ROUTE_NAMES.DETAIL_MAINTENANCE.path,
				name: ROUTE_NAMES.DETAIL_MAINTENANCE.routeName,
				redirect: { name: ROUTE_NAMES.DETAIL_MAINTENANCE_GAMES.routeName },
				meta: {
					role: ROUTE_NAMES.DETAIL_MAINTENANCE.role,
					title: ref(ROUTE_NAMES.DETAIL_MAINTENANCE.label),
					iconName: ROUTE_NAMES.DETAIL_MAINTENANCE.iconName,
					subMenu: [
						ROUTE_NAMES.DETAIL_MAINTENANCE_GAMES,
						ROUTE_NAMES.DETAIL_MAINTENANCE_PROVIDERS,
					],
					btnBack: true,
				},
				children: [
					{
						path: ROUTE_NAMES.DETAIL_MAINTENANCE_GAMES.path,
						name: ROUTE_NAMES.DETAIL_MAINTENANCE_GAMES.routeName,
						component: ROUTE_NAMES.DETAIL_MAINTENANCE_GAMES.component,
						meta: {
							role: ROUTE_NAMES.DETAIL_MAINTENANCE_GAMES.role,
						},
					},
					{
						path: ROUTE_NAMES.DETAIL_MAINTENANCE_PROVIDERS.path,
						name: ROUTE_NAMES.DETAIL_MAINTENANCE_PROVIDERS.routeName,
						component: ROUTE_NAMES.DETAIL_MAINTENANCE_PROVIDERS.component,
						meta: {
							role: ROUTE_NAMES.DETAIL_MAINTENANCE_PROVIDERS.role,
						},
					},
				],
			},

			{
				path: ROUTE_NAMES.LIST_PROVIDERS_INTEGRATIONS.path,
				name: ROUTE_NAMES.LIST_PROVIDERS_INTEGRATIONS.routeName,
				component: ROUTE_NAMES.LIST_PROVIDERS_INTEGRATIONS.component,
				query: ROUTE_NAMES.LIST_PROVIDERS_INTEGRATIONS.query,
				meta: {
					role: ROUTE_NAMES.LIST_PROVIDERS_INTEGRATIONS.role,
				},
			},
			{
				path: ROUTE_NAMES.DETAIL_PROVIDER_INTEGRATION.path,
				name: ROUTE_NAMES.DETAIL_PROVIDER_INTEGRATION.routeName,
				component: ROUTE_NAMES.DETAIL_PROVIDER_INTEGRATION.component,
				meta: {
					role: ROUTE_NAMES.DETAIL_PROVIDER_INTEGRATION.role,
					title: ref(ROUTE_NAMES.DETAIL_PROVIDER_INTEGRATION.label),
					name: ref(),
					subMenu: false,
					btnBack: true,
				},
			},
			{
				path: ROUTE_NAMES.DETAIL_INTEGRATION_ARTIFACT.path,
				name: ROUTE_NAMES.DETAIL_INTEGRATION_ARTIFACT.routeName,
				component: ROUTE_NAMES.DETAIL_INTEGRATION_ARTIFACT.component,
				redirect: {
					name: ROUTE_NAMES.DETAIL_INTEGRATION_ARTIFACT_APPEARED.routeName,
				},
				meta: {
					role: ROUTE_NAMES.DETAIL_INTEGRATION_ARTIFACT.role,
					title: ref(ROUTE_NAMES.DETAIL_INTEGRATION_ARTIFACT.label),
					name: ref(),
					subMenu: [
						ROUTE_NAMES.DETAIL_INTEGRATION_ARTIFACT_APPEARED,
						ROUTE_NAMES.DETAIL_INTEGRATION_ARTIFACT_DISAPPEARED,
						ROUTE_NAMES.DETAIL_INTEGRATION_ARTIFACT_CHANGED,
					],
					btnBack: true,
				},
				children: [
					{
						path: ROUTE_NAMES.DETAIL_INTEGRATION_ARTIFACT_APPEARED.path,
						name: ROUTE_NAMES.DETAIL_INTEGRATION_ARTIFACT_APPEARED.routeName,
						component:
							ROUTE_NAMES.DETAIL_INTEGRATION_ARTIFACT_APPEARED.component,
						meta: {
							role: ROUTE_NAMES.DETAIL_INTEGRATION_ARTIFACT_APPEARED.role,
						},
					},
					{
						path: ROUTE_NAMES.DETAIL_INTEGRATION_ARTIFACT_DISAPPEARED.path,
						name: ROUTE_NAMES.DETAIL_INTEGRATION_ARTIFACT_DISAPPEARED.routeName,
						component:
							ROUTE_NAMES.DETAIL_INTEGRATION_ARTIFACT_DISAPPEARED.component,
						meta: {
							role: ROUTE_NAMES.DETAIL_INTEGRATION_ARTIFACT_DISAPPEARED.role,
						},
					},
					{
						path: ROUTE_NAMES.DETAIL_INTEGRATION_ARTIFACT_CHANGED.path,
						name: ROUTE_NAMES.DETAIL_INTEGRATION_ARTIFACT_CHANGED.routeName,
						component:
							ROUTE_NAMES.DETAIL_INTEGRATION_ARTIFACT_CHANGED.component,
						meta: {
							role: ROUTE_NAMES.DETAIL_INTEGRATION_ARTIFACT_CHANGED.role,
						},
					},
				],
			},

			{
				path: ROUTE_NAMES.LIST_TRANSACTIONS_BY_INTEGRATIONS.path,
				name: ROUTE_NAMES.LIST_TRANSACTIONS_BY_INTEGRATIONS.routeName,
				component: ROUTE_NAMES.LIST_TRANSACTIONS_BY_INTEGRATIONS.component,
				query: ROUTE_NAMES.LIST_TRANSACTIONS_BY_INTEGRATIONS.query,
				meta: {
					role: ROUTE_NAMES.LIST_TRANSACTIONS_BY_INTEGRATIONS.role,
				},
			},
		],
	},
	PAGE_PAYMENT_SYSTEMS: {
		path: ROUTE_NAMES.PAGE_PAYMENT_SYSTEMS.path,
		name: ROUTE_NAMES.PAGE_PAYMENT_SYSTEMS.routeName,
		redirect: { name: ROUTE_NAMES.LIST_PAYMENTS_SYSTEMS.routeName },
		meta: {
			role: ROUTE_NAMES.PAGE_PAYMENT_SYSTEMS.role,
			title: ref(ROUTE_NAMES.PAGE_PAYMENT_SYSTEMS.label),
			iconName: ROUTE_NAMES.PAGE_PAYMENT_SYSTEMS.iconName,
			subMenu: [
				ROUTE_NAMES.LIST_PAYMENTS_SYSTEMS,
				ROUTE_NAMES.LIST_PAYMENTS_METHODS_WITHDRAWALS,
				ROUTE_NAMES.LIST_PAYMENTS_METHODS_DEPOSITS,
			],
		},
		children: [
			{
				path: ROUTE_NAMES.LIST_PAYMENTS_SYSTEMS.path,
				name: ROUTE_NAMES.LIST_PAYMENTS_SYSTEMS.routeName,
				component: ROUTE_NAMES.LIST_PAYMENTS_SYSTEMS.component,
				meta: {
					role: ROUTE_NAMES.LIST_PAYMENTS_SYSTEMS.role,
				},
			},
			{
				path: ROUTE_NAMES.LIST_PAYMENTS_METHODS_WITHDRAWALS.path,
				name: ROUTE_NAMES.LIST_PAYMENTS_METHODS_WITHDRAWALS.routeName,
				component: ROUTE_NAMES.LIST_PAYMENTS_METHODS_WITHDRAWALS.component,
				meta: {
					role: ROUTE_NAMES.LIST_PAYMENTS_METHODS_WITHDRAWALS.role,
				},
			},
			{
				path: ROUTE_NAMES.LIST_PAYMENTS_METHODS_DEPOSITS.path,
				name: ROUTE_NAMES.LIST_PAYMENTS_METHODS_DEPOSITS.routeName,
				component: ROUTE_NAMES.LIST_PAYMENTS_METHODS_DEPOSITS.component,
				meta: {
					role: ROUTE_NAMES.LIST_PAYMENTS_METHODS_DEPOSITS.role,
				},
			},
			{
				path: ROUTE_NAMES.DETAIL_PAYMENT_SYSTEM.path,
				name: ROUTE_NAMES.DETAIL_PAYMENT_SYSTEM.routeName,
				component: ROUTE_NAMES.DETAIL_PAYMENT_SYSTEM.component,
				meta: {
					role: ROUTE_NAMES.DETAIL_PAYMENT_SYSTEM.role,
					title: ref(ROUTE_NAMES.DETAIL_PAYMENT_SYSTEM.label),
					name: ref(''),
					btnBack: true,
					subMenu: false,
				},
			},
		],
	},
	PAGE_PAYMENTS: {
		path: ROUTE_NAMES.PAGE_PAYMENTS.path,
		name: ROUTE_NAMES.PAGE_PAYMENTS.routeName,
		redirect: { name: ROUTE_NAMES.LIST_DEPOSIT_REQUESTS.routeName },
		meta: {
			role: ROUTE_NAMES.PAGE_PAYMENTS.role,
			title: ref(ROUTE_NAMES.PAGE_PAYMENTS.label),
			iconName: ROUTE_NAMES.PAGE_PAYMENTS.iconName,
			subMenu: [
				ROUTE_NAMES.LIST_DEPOSIT_REQUESTS,
				ROUTE_NAMES.LIST_DEPOSITS,
				ROUTE_NAMES.LIST_WITHDRAWALS_REQUESTS,
				ROUTE_NAMES.LIST_WITHDRAWALS,
			],
		},
		children: [
			{
				path: ROUTE_NAMES.LIST_DEPOSIT_REQUESTS.path,
				name: ROUTE_NAMES.LIST_DEPOSIT_REQUESTS.routeName,
				component: ROUTE_NAMES.LIST_DEPOSIT_REQUESTS.component,
				query: ROUTE_NAMES.LIST_DEPOSIT_REQUESTS.component,
				meta: {
					role: ROUTE_NAMES.LIST_DEPOSIT_REQUESTS.role,
				},
			},
			{
				path: ROUTE_NAMES.LIST_DEPOSITS.path,
				name: ROUTE_NAMES.LIST_DEPOSITS.routeName,
				component: ROUTE_NAMES.LIST_DEPOSITS.component,
				query: ROUTE_NAMES.LIST_DEPOSITS.component,
				meta: {
					role: ROUTE_NAMES.LIST_DEPOSITS.role,
				},
			},
			{
				path: ROUTE_NAMES.LIST_WITHDRAWALS_REQUESTS.path,
				name: ROUTE_NAMES.LIST_WITHDRAWALS_REQUESTS.routeName,
				component: ROUTE_NAMES.LIST_WITHDRAWALS_REQUESTS.component,
				query: ROUTE_NAMES.LIST_WITHDRAWALS_REQUESTS.component,
				meta: {
					role: ROUTE_NAMES.LIST_WITHDRAWALS_REQUESTS.role,
				},
			},
			{
				path: ROUTE_NAMES.DETAIL_WITHDRAWAL_INVOICE.path,
				name: ROUTE_NAMES.DETAIL_WITHDRAWAL_INVOICE.routeName,
				component: ROUTE_NAMES.DETAIL_WITHDRAWAL_INVOICE.component,
				meta: {
					role: ROUTE_NAMES.DETAIL_WITHDRAWAL_INVOICE.role,
					title: ref(ROUTE_NAMES.DETAIL_WITHDRAWAL_INVOICE.label),
					name: ref(),
					subMenu: false,
					btnBack: true,
				},
			},
			{
				path: ROUTE_NAMES.LIST_WITHDRAWALS.path,
				name: ROUTE_NAMES.LIST_WITHDRAWALS.routeName,
				component: ROUTE_NAMES.LIST_WITHDRAWALS.component,
				query: ROUTE_NAMES.LIST_WITHDRAWALS.query,
				meta: {
					role: ROUTE_NAMES.LIST_WITHDRAWALS.role,
				},
			},
		],
	},
	PAGE_REFERRAL: {
		path: ROUTE_NAMES.PAGE_REFERRAL.path,
		name: ROUTE_NAMES.PAGE_REFERRAL.routeName,
		redirect: { name: ROUTE_NAMES.LIST_REFERRAL.routeName },
		meta: {
			role: ROUTE_NAMES.PAGE_REFERRAL.role,
			title: ref(ROUTE_NAMES.PAGE_REFERRAL.label),
			iconName: ROUTE_NAMES.PAGE_REFERRAL.iconName,
			subMenu: false,
		},
		children: [
			{
				path: ROUTE_NAMES.LIST_REFERRAL.path,
				name: ROUTE_NAMES.LIST_REFERRAL.routeName,
				query: ROUTE_NAMES.LIST_REFERRAL.query,
				component: ROUTE_NAMES.LIST_REFERRAL.component,
				meta: {
					role: ROUTE_NAMES.LIST_REFERRAL.role,
				},
			},
			{
				path: ROUTE_NAMES.DETAIL_REFERRAL.path,
				name: ROUTE_NAMES.DETAIL_REFERRAL.routeName,
				component: ROUTE_NAMES.DETAIL_REFERRAL.component,
				meta: {
					role: ROUTE_NAMES.DETAIL_REFERRAL.role,
					title: ref(ROUTE_NAMES.DETAIL_REFERRAL.label),
					name: ref(),
					subMenu: false,
					btnBack: true,
				},
			},
		],
	},
	PAGE_PARTNERS_PROGRAM: {
		path: ROUTE_NAMES.PAGE_PARTNERS_PROGRAM.path,
		name: ROUTE_NAMES.PAGE_PARTNERS_PROGRAM.routeName,
		redirect: { name: ROUTE_NAMES.LIST_PARTNERS_PROGRAM.routeName },
		meta: {
			role: ROUTE_NAMES.PAGE_PARTNERS_PROGRAM.role,
			title: ref(ROUTE_NAMES.PAGE_PARTNERS_PROGRAM.label),
			iconName: ROUTE_NAMES.PAGE_PARTNERS_PROGRAM.iconName,
			subMenu: [
				ROUTE_NAMES.LIST_PARTNERS_PROGRAM,
				ROUTE_NAMES.LIST_PARTNERS_POSTBACK,
			],
		},
		children: [
			{
				path: ROUTE_NAMES.LIST_PARTNERS_PROGRAM.path,
				name: ROUTE_NAMES.LIST_PARTNERS_PROGRAM.routeName,
				query: ROUTE_NAMES.LIST_PARTNERS_PROGRAM.query,
				component: ROUTE_NAMES.LIST_PARTNERS_PROGRAM.component,
				meta: {
					role: ROUTE_NAMES.LIST_PARTNERS_PROGRAM.role,
				},
			},
			{
				path: ROUTE_NAMES.LIST_PARTNERS_POSTBACK.path,
				name: ROUTE_NAMES.LIST_PARTNERS_POSTBACK.routeName,
				query: ROUTE_NAMES.LIST_PARTNERS_POSTBACK.query,
				component: ROUTE_NAMES.LIST_PARTNERS_POSTBACK.component,
				meta: {
					role: ROUTE_NAMES.LIST_PARTNERS_POSTBACK.role,
				},
			},
			{
				path: ROUTE_NAMES.DETAIL_PARTNERS_PROGRAM.path,
				name: ROUTE_NAMES.DETAIL_PARTNERS_PROGRAM.routeName,
				component: ROUTE_NAMES.DETAIL_PARTNERS_PROGRAM.component,
				meta: {
					role: ROUTE_NAMES.DETAIL_PARTNERS_PROGRAM.role,
					btnBack: true,
					title: ref(ROUTE_NAMES.DETAIL_PARTNERS_PROGRAM.label),
					name: ref(),
					subMenu: false,
				},
			},
			{
				path: ROUTE_NAMES.DETAIL_PARTNERS_POSTBACK.path,
				name: ROUTE_NAMES.DETAIL_PARTNERS_POSTBACK.routeName,
				component: ROUTE_NAMES.DETAIL_PARTNERS_POSTBACK.component,
				meta: {
					role: ROUTE_NAMES.DETAIL_PARTNERS_POSTBACK.role,
					btnBack: true,
					title: ref(ROUTE_NAMES.DETAIL_PARTNERS_POSTBACK.label),
					name: ref(),
					subMenu: false,
				},
			},
		],
	},
	PAGE_CMS: {
		path: ROUTE_NAMES.PAGE_CMS.path,
		name: ROUTE_NAMES.PAGE_CMS.routeName,
		redirect: { name: ROUTE_NAMES.LIST_WIDGETS.routeName },
		meta: {
			role: ROUTE_NAMES.PAGE_CMS.role,
			title: ref(ROUTE_NAMES.PAGE_CMS.label),
			iconName: ROUTE_NAMES.PAGE_CMS.iconName,
			subMenu: [
				ROUTE_NAMES.LIST_WIDGETS,
				ROUTE_NAMES.LIST_PROMO,
				ROUTE_NAMES.LIST_NEWS,
				ROUTE_NAMES.LIST_TEXTS,
			],
		},
		children: [
			{
				path: ROUTE_NAMES.LIST_WIDGETS.path,
				name: ROUTE_NAMES.LIST_WIDGETS.routeName,
				component: ROUTE_NAMES.LIST_WIDGETS.component,
				meta: {
					role: ROUTE_NAMES.LIST_WIDGETS.role,
				},
			},

			{
				path: ROUTE_NAMES.LIST_PROMO.path,
				name: ROUTE_NAMES.LIST_PROMO.routeName,
				component: ROUTE_NAMES.LIST_PROMO.component,
				query: ROUTE_NAMES.LIST_PROMO.query,
				meta: {
					role: ROUTE_NAMES.LIST_PROMO.role,
				},
			},
			{
				path: ROUTE_NAMES.DETAIL_PROMO.path,
				name: ROUTE_NAMES.DETAIL_PROMO.routeName,
				component: ROUTE_NAMES.DETAIL_PROMO.component,
				meta: {
					role: ROUTE_NAMES.DETAIL_PROMO.role,
					title: ref(ROUTE_NAMES.DETAIL_PROMO.label),
					name: ref(),
					subMenu: false,
					btnBack: true,
				},
			},
			{
				path: ROUTE_NAMES.CREATE_PROMO.path,
				name: ROUTE_NAMES.CREATE_PROMO.routeName,
				component: ROUTE_NAMES.CREATE_PROMO.component,
				meta: {
					role: ROUTE_NAMES.CREATE_PROMO.role,
					title: ref(ROUTE_NAMES.CREATE_PROMO.label),
					subMenu: false,
					btnBack: true,
				},
			},

			{
				path: ROUTE_NAMES.LIST_NEWS.path,
				name: ROUTE_NAMES.LIST_NEWS.routeName,
				component: ROUTE_NAMES.LIST_NEWS.component,
				meta: {
					role: ROUTE_NAMES.LIST_NEWS.role,
				},
			},
			{
				path: ROUTE_NAMES.DETAIL_NEWS.path,
				name: ROUTE_NAMES.DETAIL_NEWS.routeName,
				component: ROUTE_NAMES.DETAIL_NEWS.component,
				meta: {
					role: ROUTE_NAMES.DETAIL_NEWS.role,
					title: ref(ROUTE_NAMES.DETAIL_NEWS.label),
					name: ref(),
					subMenu: false,
					btnBack: true,
				},
			},
			{
				path: ROUTE_NAMES.CREATE_NEWS.path,
				name: ROUTE_NAMES.CREATE_NEWS.routeName,
				component: ROUTE_NAMES.CREATE_NEWS.component,
				meta: {
					role: ROUTE_NAMES.CREATE_NEWS.role,
					title: ref(ROUTE_NAMES.CREATE_NEWS.label),
					subMenu: false,
					btnBack: true,
				},
			},

			{
				path: ROUTE_NAMES.LIST_TEXTS.path,
				name: ROUTE_NAMES.LIST_TEXTS.routeName,
				component: ROUTE_NAMES.LIST_TEXTS.component,
				meta: {
					role: ROUTE_NAMES.LIST_TEXTS.role,
				},
			},
			{
				path: ROUTE_NAMES.DETAIL_TEXT.path,
				name: ROUTE_NAMES.DETAIL_TEXT.routeName,
				component: ROUTE_NAMES.DETAIL_TEXT.component,
				meta: {
					role: ROUTE_NAMES.DETAIL_TEXT.role,
					title: ref(ROUTE_NAMES.DETAIL_TEXT.label),
					btnBack: true,
					subMenu: false,
				},
			},
			{
				path: ROUTE_NAMES.CREATE_TEXT.path,
				name: ROUTE_NAMES.CREATE_TEXT.routeName,
				component: ROUTE_NAMES.CREATE_TEXT.component,
				meta: {
					role: ROUTE_NAMES.CREATE_TEXT.role,
					title: ref(ROUTE_NAMES.CREATE_TEXT.label),
					subMenu: false,
					btnBack: true,
				},
			},
		],
	},
	PAGE_CHAT: {
		path: ROUTE_NAMES.PAGE_CHAT.path,
		name: ROUTE_NAMES.PAGE_CHAT.routeName,
		redirect: { name: ROUTE_NAMES.LIST_MESSAGES.routeName },
		meta: {
			role: ROUTE_NAMES.PAGE_CHAT.role,
			title: ref(ROUTE_NAMES.PAGE_CHAT.label),
			iconName: ROUTE_NAMES.PAGE_CHAT.iconName,
			subMenu: [ROUTE_NAMES.LIST_MESSAGES, ROUTE_NAMES.BLACK_LIST],
		},
		children: [
			{
				path: ROUTE_NAMES.LIST_MESSAGES.path,
				name: ROUTE_NAMES.LIST_MESSAGES.routeName,
				component: ROUTE_NAMES.LIST_MESSAGES.component,
				meta: {
					role: ROUTE_NAMES.LIST_MESSAGES.role,
				},
			},
			{
				path: ROUTE_NAMES.BLACK_LIST.path,
				name: ROUTE_NAMES.BLACK_LIST.routeName,
				component: ROUTE_NAMES.BLACK_LIST.component,
				meta: {
					role: ROUTE_NAMES.BLACK_LIST.role,
				},
			},
		],
	},
	PAGE_BONUS: {
		path: ROUTE_NAMES.PAGE_BONUS.path,
		name: ROUTE_NAMES.PAGE_BONUS.routeName,
		redirect: { name: ROUTE_NAMES.LIST_LEVELS.routeName },
		meta: {
			role: ROUTE_NAMES.PAGE_BONUS.role,
			title: ref(ROUTE_NAMES.PAGE_BONUS.label),
			iconName: ROUTE_NAMES.PAGE_BONUS.iconName,
			subMenu: [
				ROUTE_NAMES.LIST_LEVELS,
				ROUTE_NAMES.LIST_BONUS_PRESETS,
				ROUTE_NAMES.LIST_CONFIG_CASHBACK,
				ROUTE_NAMES.LIST_CONFIG_REFERRAL,
				ROUTE_NAMES.LIST_CONFIG_DEPOSITS,
				ROUTE_NAMES.LIST_BONUSES,
			],
		},
		children: [
			{
				path: ROUTE_NAMES.LIST_LEVELS.path,
				name: ROUTE_NAMES.LIST_LEVELS.routeName,
				component: ROUTE_NAMES.LIST_LEVELS.component,
				meta: {
					role: ROUTE_NAMES.LIST_LEVELS.role,
					title: ref(ROUTE_NAMES.LIST_LEVELS.label),
				},
			},
			{
				path: ROUTE_NAMES.LIST_BONUS_PRESETS.path,
				name: ROUTE_NAMES.LIST_BONUS_PRESETS.routeName,
				component: ROUTE_NAMES.LIST_BONUS_PRESETS.component,
				meta: {
					role: ROUTE_NAMES.LIST_BONUS_PRESETS.role,
					title: ref(ROUTE_NAMES.LIST_BONUS_PRESETS.label),
				},
			},
			{
				path: ROUTE_NAMES.LIST_CONFIG_CASHBACK.path,
				name: ROUTE_NAMES.LIST_CONFIG_CASHBACK.routeName,
				component: ROUTE_NAMES.LIST_CONFIG_CASHBACK.component,
				meta: {
					role: ROUTE_NAMES.LIST_CONFIG_CASHBACK.role,
					title: ref(ROUTE_NAMES.LIST_CONFIG_CASHBACK.label),
				},
			},
			{
				path: ROUTE_NAMES.LIST_CONFIG_REFERRAL.path,
				name: ROUTE_NAMES.LIST_CONFIG_REFERRAL.routeName,
				component: ROUTE_NAMES.LIST_CONFIG_REFERRAL.component,
				meta: {
					role: ROUTE_NAMES.LIST_CONFIG_REFERRAL.role,
					title: ref(ROUTE_NAMES.LIST_CONFIG_REFERRAL.label),
				},
			},
			{
				path: ROUTE_NAMES.LIST_CONFIG_DEPOSITS.path,
				name: ROUTE_NAMES.LIST_CONFIG_DEPOSITS.routeName,
				component: ROUTE_NAMES.LIST_CONFIG_DEPOSITS.component,
				meta: {
					role: ROUTE_NAMES.LIST_CONFIG_DEPOSITS.role,
					title: ref(ROUTE_NAMES.LIST_CONFIG_DEPOSITS.label),
				},
			},
			{
				path: ROUTE_NAMES.LIST_BONUSES.path,
				name: ROUTE_NAMES.LIST_BONUSES.routeName,
				component: ROUTE_NAMES.LIST_BONUSES.component,
				meta: {
					role: ROUTE_NAMES.LIST_BONUSES.role,
					title: ref(ROUTE_NAMES.LIST_BONUSES.label),
				},
			},

			{
				path: ROUTE_NAMES.CREATE_BONUS_PRESET.path,
				name: ROUTE_NAMES.CREATE_BONUS_PRESET.routeName,
				component: ROUTE_NAMES.CREATE_BONUS_PRESET.component,
				meta: {
					role: ROUTE_NAMES.CREATE_BONUS_PRESET.role,
					title: ref(ROUTE_NAMES.CREATE_BONUS_PRESET.label),
					subMenu: false,
					btnBack: true,
				},
			},
			{
				path: ROUTE_NAMES.DETAIL_BONUS_PRESET.path,
				name: ROUTE_NAMES.DETAIL_BONUS_PRESET.routeName,
				component: ROUTE_NAMES.DETAIL_BONUS_PRESET.component,
				meta: {
					role: ROUTE_NAMES.DETAIL_BONUS_PRESET.role,
					title: ref(ROUTE_NAMES.DETAIL_BONUS_PRESET.label),
					subMenu: false,
					btnBack: true,
				},
			},

			{
				path: ROUTE_NAMES.CREATE_CONFIG_DEPOSIT.path,
				name: ROUTE_NAMES.CREATE_CONFIG_DEPOSIT.routeName,
				component: ROUTE_NAMES.CREATE_CONFIG_DEPOSIT.component,
				meta: {
					role: ROUTE_NAMES.CREATE_CONFIG_DEPOSIT.role,
					title: ref(ROUTE_NAMES.CREATE_CONFIG_DEPOSIT.label),
					subMenu: false,
					btnBack: true,
				},
			},
			{
				path: ROUTE_NAMES.DETAIL_CONFIG_DEPOSIT.path,
				name: ROUTE_NAMES.DETAIL_CONFIG_DEPOSIT.routeName,
				component: ROUTE_NAMES.DETAIL_CONFIG_DEPOSIT.component,
				meta: {
					role: ROUTE_NAMES.DETAIL_CONFIG_DEPOSIT.role,
					title: ref(ROUTE_NAMES.DETAIL_CONFIG_DEPOSIT.label),
					name: ref(''),
					subMenu: false,
					btnBack: true,
				},
			},
		],
	},
	PAGE_MISSIONS: {
		path: ROUTE_NAMES.PAGE_MISSIONS.path,
		name: ROUTE_NAMES.PAGE_MISSIONS.routeName,
		redirect: { name: ROUTE_NAMES.LIST_MISSIONS.routeName },
		meta: {
			role: ROUTE_NAMES.PAGE_MISSIONS.role,
			title: ref(ROUTE_NAMES.PAGE_MISSIONS.label),
			iconName: ROUTE_NAMES.PAGE_MISSIONS.iconName,
			subMenu: [ROUTE_NAMES.LIST_MISSIONS, ROUTE_NAMES.LIST_MISSIONS_PRESETS],
		},
		children: [
			{
				path: ROUTE_NAMES.LIST_MISSIONS.path,
				name: ROUTE_NAMES.LIST_MISSIONS.routeName,
				component: ROUTE_NAMES.LIST_MISSIONS.component,
				meta: {
					role: ROUTE_NAMES.LIST_MISSIONS.role,
					title: ref(ROUTE_NAMES.LIST_MISSIONS.label),
				},
			},
			{
				path: ROUTE_NAMES.LIST_MISSIONS_PRESETS.path,
				name: ROUTE_NAMES.LIST_MISSIONS_PRESETS.routeName,
				component: ROUTE_NAMES.LIST_MISSIONS_PRESETS.component,
				meta: {
					role: ROUTE_NAMES.LIST_MISSIONS_PRESETS.role,
					title: ref(ROUTE_NAMES.LIST_MISSIONS_PRESETS.label),
				},
			},

			{
				path: ROUTE_NAMES.DETAIL_MISSION.path,
				name: ROUTE_NAMES.DETAIL_MISSION.routeName,
				component: ROUTE_NAMES.DETAIL_MISSION.component,
				meta: {
					role: ROUTE_NAMES.DETAIL_MISSION.role,
					title: ref(ROUTE_NAMES.DETAIL_MISSION.label),
					name: ref(''),
					subMenu: false,
					btnBack: true,
				},
			},

			{
				path: ROUTE_NAMES.CREATE_MISSION_PRESET.path,
				name: ROUTE_NAMES.CREATE_MISSION_PRESET.routeName,
				component: ROUTE_NAMES.CREATE_MISSION_PRESET.component,
				meta: {
					role: ROUTE_NAMES.CREATE_MISSION_PRESET.role,
					title: ref(ROUTE_NAMES.CREATE_MISSION_PRESET.label),
					subMenu: false,
					btnBack: true,
				},
			},
			{
				path: ROUTE_NAMES.DETAIL_MISSION_PRESET.path,
				name: ROUTE_NAMES.DETAIL_MISSION_PRESET.routeName,
				component: ROUTE_NAMES.DETAIL_MISSION_PRESET.component,
				meta: {
					role: ROUTE_NAMES.DETAIL_MISSION_PRESET.role,
					title: ref(ROUTE_NAMES.DETAIL_MISSION_PRESET.label),
					subMenu: false,
					btnBack: true,
				},
			},
		],
	},
	PAGE_TRANSLATIONS: {
		path: ROUTE_NAMES.PAGE_TRANSLATIONS.path,
		name: ROUTE_NAMES.PAGE_TRANSLATIONS.routeName,
		redirect: { name: ROUTE_NAMES.LIST_LANGUAGES.routeName },
		meta: {
			role: ROUTE_NAMES.PAGE_TRANSLATIONS.role,
			title: ref(ROUTE_NAMES.PAGE_TRANSLATIONS.label),
			iconName: ROUTE_NAMES.PAGE_TRANSLATIONS.iconName,
			subMenu: [ROUTE_NAMES.LIST_LANGUAGES, ROUTE_NAMES.LIST_DICTIONARY],
		},
		children: [
			{
				path: ROUTE_NAMES.LIST_LANGUAGES.path,
				name: ROUTE_NAMES.LIST_LANGUAGES.routeName,
				component: ROUTE_NAMES.LIST_LANGUAGES.component,
				meta: {
					role: ROUTE_NAMES.LIST_LANGUAGES.role,
					title: ref(ROUTE_NAMES.LIST_LANGUAGES.label),
				},
			},
			{
				path: ROUTE_NAMES.LIST_DICTIONARY.path,
				name: ROUTE_NAMES.LIST_DICTIONARY.routeName,
				component: ROUTE_NAMES.LIST_DICTIONARY.component,
				meta: {
					role: ROUTE_NAMES.LIST_DICTIONARY.role,
					title: ref(ROUTE_NAMES.LIST_DICTIONARY.label),
				},
			},
		],
	},
	PAGE_CATALOG: {
		path: ROUTE_NAMES.PAGE_CATALOG.path,
		name: ROUTE_NAMES.PAGE_CATALOG.routeName,
		redirect: { name: ROUTE_NAMES.LIST_CURRENCY_CATALOG.routeName },
		meta: {
			role: ROUTE_NAMES.PAGE_CATALOG.role,
			title: ref(ROUTE_NAMES.PAGE_CATALOG.label),
			iconName: ROUTE_NAMES.PAGE_CATALOG.iconName,
			subMenu: [ROUTE_NAMES.LIST_CURRENCY_CATALOG],
		},
		children: [
			{
				path: ROUTE_NAMES.LIST_CURRENCY_CATALOG.path,
				name: ROUTE_NAMES.LIST_CURRENCY_CATALOG.routeName,
				component: ROUTE_NAMES.LIST_CURRENCY_CATALOG.component,
				meta: {
					role: ROUTE_NAMES.LIST_CURRENCY_CATALOG.role,
					title: ref(ROUTE_NAMES.LIST_CURRENCY_CATALOG.label),
				},
			},
		],
	},
}
